import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, Theme, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { ReactNode } from "react";

import { addSelectionOptionsToMenuItem } from "shared-ui/MenuItem/utils";
import { Loading } from "shared-ui/global/Loading";
import { MenuSelectionItemWithAppearance } from "shared-ui/MenuSelection/utils";
import { MenuItemPreviewFragment, useMenuItemForSelectionFormQuery } from "../../types";
import NewForm from "./NewForm";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    header: {
      display: "flex",
      alignItems: "center",
      paddingBottom: theme.spacing(),
    },
    back: {
      marginRight: theme.spacing(),
    },
  })
);

interface MenuSelectionItemNewProps {
  menuSelectionItemId: string;
  menuItem: MenuItemPreviewFragment;
  maxAmount: number | null; // Result of getMenuItemMaxAmount function, will change based on amount in diningStation
  availableForOrder: boolean;
  allowSpecialRequests: boolean;
  onDone: (menuSelectionItem: MenuSelectionItemWithAppearance) => void;
  onChange: (menuSelectionItem: MenuSelectionItemWithAppearance) => void;
  onBack: () => void;
  selectionType: string; // i.e. Order, Log, Bulk Order/Plate
  children?: ReactNode;
}

const MenuSelectionItemNew = ({
  menuSelectionItemId,
  menuItem,
  maxAmount,
  availableForOrder,
  allowSpecialRequests,
  selectionType,
  onDone,
  onBack,
  onChange,
  children
}: MenuSelectionItemNewProps) => {
  const classes = useStyles();
  const { data } = useMenuItemForSelectionFormQuery({
    variables: {
      menuItemId: menuItem.id,
    },
  });

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <IconButton
          size="small"
          onClick={onBack}
          className={classes.back}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h3">
          <strong>Add Item to {selectionType}</strong>
        </Typography>
      </div>
      {!data ? (
        <Loading />
      ) : (
        <NewForm
          menuSelectionItemId={menuSelectionItemId}
          maxAmount={maxAmount}
          availableForOrder={availableForOrder}
          allowSpecialRequests={allowSpecialRequests}
          selectionType={selectionType}
          onDone={onDone}
          onChange={onChange}
          menuItem={addSelectionOptionsToMenuItem(data.menuItem, [])}
          children={children}
        />
      )}
    </div>
  );
};

export default MenuSelectionItemNew;
